import { Injectable, Input} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResetpasswordService {
  
  constructor(private _http: HttpClient) { }

  public ResetPassword(_email: string, _id: number) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true
    };

    const body = JSON.stringify({
      email: _email,
      accountid: _id
    });

    return this._http.post(environment.resetUrl, body, httpOptions);    
  }

}
